import { useEffect } from 'preact/hooks';
import { route } from 'preact-router';

const Redirect = ({ to }) => {
  useEffect(() => {
    if (to) {
      const url = new URL(to, window.location.origin);
      const params = new URLSearchParams(window.location.search);
      params.delete('ml'); // remove magic link token
      if (['/map', '/home', '/plans', '/start', '/prices', '/highlights'].includes(url.pathname) && params.size > 0) {
        params.forEach((value, key) => {
          url.searchParams.set(key, value);
        });
      }
      route(`${url.pathname}${url.search}`, true);
    }
  }, [to]);

  return null;
};

export default Redirect;
